export function arraysHaveTheSameValues(first, second)
{
    if (first.length !== second.length) return false

    let haveTheSameValues = true
    first = first.sort()
    second = second.sort()

    for (let i = 0; i < first.length; i += 1)
    {
        if (first[i] !== second[i]) haveTheSameValues = false
    }

    return haveTheSameValues
}



// WEBPACK FOOTER //
// ./src/scripts/utils/Array.js